var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene"},[_c('canvas',{ref:"pano",staticClass:"pano"})])}
var staticRenderFns = []

export { render, staticRenderFns }